<app-modal
  modalId="caravan-trade"
  [showCloseButton]="true"
  [allowEscToClose]="true"
  [closeOnBackdropClick]="true"
>
  <span title>{{ trader()?.name ?? 'Trader' }}</span>

  @if (trader(); as traderContent) {
    <p subtitle>{{ traderContent.description }}</p>
  }

  <div body class="flex flex-col gap-2">
    @if (commission(); as activeCommission) {
      <app-slot-commission
        [row]="activeCommission"
        [isInLocationModal]="true"
        [fulfill]="() => fulfillCommission()"
      />
    }

    @if (tokenTrades().length > 0) {
      <div class="flex flex-col gap-2">
        @for (row of tokenTrades(); track row.index) {
          <app-slot-caravan-token-trade
            [trade]="row.trade"
            (activate)="buyTokenTrade(row)"
          />
        }
      </div>
    }

    <div class="flex flex-col gap-2">
      @for (row of trades(); track row.index) {
        <app-slot-caravan-trade
          [row]="row"
          (activate)="requestTrade(row, $event)"
        />
      } @empty {
        <app-blank-slate>
          This trader has nothing in stock right now.
        </app-blank-slate>
      }
    </div>

    @if (timerLabel(); as label) {
      <div
        class="text-sm text-center"
        [class.text-success]="timerUrgency() === 'safe'"
        [class.text-warning]="timerUrgency() === 'warning'"
        [class.text-error]="timerUrgency() === 'danger'"
      >
        This merchant will be leaving in {{ label }}.
      </div>
    }
  </div>
</app-modal>

<app-modal-trade-quantity />
